import { Button, DatePicker, Form, Input, Modal, Select, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import useManual from '../hook/useManual';
import { useCallback } from 'react';
import moment from 'moment';
import {
    DownOutlined
} from '@ant-design/icons';
import { useState } from 'react';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';

export default function ModalManual({ open, manualForm, setOpen }) {
    const { t } = useTranslation('data-breach');
    const [editFlag, setEditFlag] = useState(false);
    const [change, setChange] = useState(false);

    const handelOk = async () => { 
        await manualForm.resetFields();
        await setEditFlag(false);
        await setChange(false);
        await setOpen(false);
    };

    const keepEditing = async () => {
        setEditFlag(false);
    };

    const _handleCancel = async () => {
        if (change) {
            setEditFlag(true)
        } else {
            setEditFlag(false)
            setOpen(false);
            await manualForm.resetFields();
        }
    };

    const { userOptions, manualSubmit } = useManual(_handleCancel);
    const [selectedReviewer, setSelectedReviewer] =  useState([]);

    const onFinish = useCallback(
        async (values) => {
            await setEditFlag(false);
            await setChange(false);
            await setOpen(false);
            const jsonData = {
                groupQuestion: [
                    [],
                    [],
                    [
                        {
                            questionName: '<p>วันเวลาที่ทราบเหตุโดยประมาณ</p>',
                            answerType: 'DATE_TIME',
                            storyId: '9c2d3c7691f011ef867dfa163e89e3c8',
                            value: moment(values.date).format(
                                'DD/MM/YYYY HH:mm'
                            ),
                        },
                    ],
                    [],
                ],
            };

            const payload = {
                jsonData: JSON.stringify(jsonData),
                dataBreachEventName: values.dataBreachEventName,
                assignee: values.assignee,
            };
            manualSubmit(payload);
        },
        [manualSubmit]
    );
    const suffix = (
        <>
            <span>
                {selectedReviewer.length} / {3}
            </span>
            <DownOutlined />
        </>
    );
    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={_handleCancel}
            title={t('Report Incident')}
        >
            <Form 
                onFinish={onFinish} 
                form={manualForm} layout="vertical"
                onFieldsChange={(_, allFields) => {
                    const allUndefined = allFields.every(item => item.value === undefined);
                    if (allFields.length > 0) {
                        !allUndefined && setChange(true);
                    }
                }}
            >
                <Form.Item
                    name="dataBreachEventName"
                    label={t('Name of the incident')}
                    rules={[
                        {
                            required: true,
                            message: t('requiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        placeholder={t('Name of the incident')}
                        maxLength={100}
                        showCount
                    />
                </Form.Item>
                <Form.Item
                    name="date"
                    label={t('Date and time of incident')}
                    rules={[
                        {
                            required: true,
                            message: t('requiredField'),
                        },
                    ]}
                >
                    <DatePicker
                        style={{ width: '100%' }}
                        size="large"
                        showTime
                        format="DD/MM/YYYY HH:mm"
                        placeholder="DD/MM/YYYY HH:mm"
                    />
                </Form.Item>
                <Form.Item
                    name="assignee"
                    label={t('Responsible person max 3')}
                    rules={[
                        {
                            required: true,
                            message: t('requiredField'),
                        },
                    ]}
                >
                    <Select
                        size="large"
                        className="w-full"
                        placeholder={t('Responsible person placeholder')}
                        optionFilterProp="children"
                        maxCount={3}
                        mode="multiple"
                        value={selectedReviewer}
                        onChange={(selectedValues) => {
                            if (selectedValues.length <= 3) {
                              setSelectedReviewer(selectedValues);
                            }
                          }}
                        suffixIcon={suffix}

                    >
                        {userOptions.map((item) => (
                            <Select.Option
                                key={item.userId}
                                value={item.userId}
                                disabled={
                                    selectedReviewer.length >= 3 &&
                                    !selectedReviewer.includes(item.userId)
                                }
                            >
                                {item.fullName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item className="flex justify-center mt-4">
                    <Space>
                        <Button
                            onClick={() => {
                                _handleCancel();
                            }}
                            size="large"
                            className="border-purple-PHX text-purple-PHX px-10"
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            htmlType="submit"
                            size="large"
                            type="primary"
                            className="px-10"
                        >
                            {t('Save')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
            <ModalDiscardChanges
                open={editFlag && change}
                handelOk={handelOk}
                handelClose={() => keepEditing()}
            />
        </Modal>
    );
}
